<template>
    <div class="icon">
        <div class="rotator"></div>
    </div>
</template>

<script>
export default {name: 'Loading'}
</script>

<style scoped>
    .icon {
        display: inline-block;
    }

    .icon .rotator {
        width: 15px;
        height: 15px;
        border: 2px solid transparent;
        border-left-color: gray;
        border-right-color: gray;
        border-radius: 50%;
        animation-name: rotation;
        animation-duration: 1s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
    }

    @keyframes rotation {
        0% {
            transform: rotate(0deg) scale(.9);
        }

        50% {
            transform: rotate(360deg) scale(1);
        }

        100% {
            transform: rotate(720deg) scale(.9);
        }
    }
</style>
